import { useState, useEffect } from 'react';
import { storage } from '../utils/storage';

const STORAGE_KEY = 'customer-view-mode';
const VALID_MODES = ['list', 'grid', 'cards'];
const DEFAULT_MODE = 'grid';

/**
 * Hook para manejar el modo de visualización de productos
 * Persiste la preferencia en localStorage
 *
 * @param {string} initialMode - Modo inicial ('list' | 'grid' | 'cards')
 * @returns {[string, function]} - [viewMode, setViewMode]
 */
function useViewMode(initialMode = DEFAULT_MODE) {
  const [viewMode, setViewMode] = useState(() => {
    // Intentar recuperar del localStorage
    try {
      const stored = storage.get(STORAGE_KEY);
      if (stored && VALID_MODES.includes(stored)) {
        return stored;
      }
    } catch (e) {
      // localStorage no disponible
    }
    return VALID_MODES.includes(initialMode) ? initialMode : DEFAULT_MODE;
  });

  // Persistir cambios en localStorage
  useEffect(() => {
    try {
      storage.set(STORAGE_KEY, viewMode);
    } catch (e) {
      // localStorage no disponible
    }
  }, [viewMode]);

  // Wrapper para validar el modo antes de setear
  const handleSetViewMode = (mode) => {
    if (VALID_MODES.includes(mode)) {
      setViewMode(mode);
    }
  };

  return [viewMode, handleSetViewMode];
}

export default useViewMode;
